import {
  dateFormatDay,
  dateFormatEnd,
  dateFormatStart,
} from "components/newDateFormat";
import { PLACEHOLDER } from "constants/baseStyle";
import { POST_WALLET_DELETE_MEMBER_FETCH } from "constants/pathConstant";
import { useMutationCustom } from "hooks/useMutationCustom";
import { useToastCustom } from "hooks/useToastCustom";
import { useEffect, useState } from "react";
import { Search, Wrapper } from "template/SearchTemplate.style";

// 검색 -> 탈퇴 회원관리 :: 탈퇴 회원 조회 (http://localhost:3000/super/search/gone-user)
const WalletDropUserSearch = ({
  setDropUserList,
  setPage,
  currentPage,
  pageSize,
  setSearchData,
  searchData,
  setIsSearch,
}) => {
  const toast = useToastCustom();

  const [memberName, setMemberName] = useState("");
  const [memberCode, setMemberCode] = useState("");
  const [recommenderName, setRecommenderName] = useState("");
  const [recommenderCode, setRecommenderCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [createFromDt, setCreateFromDt] = useState("");
  const [createToDt, setCreateToDt] = useState(dateFormatDay(new Date()));
  const [deleteFromDt, setDeleteFromDt] = useState("");
  const [deleteToDt, setDeleteToDt] = useState(dateFormatDay(new Date()));

  const { mutate } = useMutationCustom(POST_WALLET_DELETE_MEMBER_FETCH);

  // page, size 바뀔때
  useEffect(() => {
    if (!Object.keys(searchData)[0]) return;

    const researchData = { ...searchData, pageSize, currentPage };

    mutate(researchData, {
      onSuccess: (data) => {
        setDropUserList(data);
      },
      onError: () => {
        toast("데이터 조회 실패", "error");
      },
    });
  }, [currentPage, pageSize]);

  useEffect(() => {
    handleSearch();
  }, []);

  const handleSearch = () => {
    setPage(1);

    const searchCond = {
      memberName,
      memberCode,
      recommenderName,
      recommenderCode,
      mobile,
      email,
      walletAddress,
      createFromDt: createFromDt && dateFormatStart(createFromDt),
      createToDt: dateFormatEnd(createToDt),
      deleteFromDt: deleteFromDt && dateFormatStart(deleteFromDt),
      deleteToDt: dateFormatEnd(deleteToDt),
      pageSize,
      currentPage,
    };

    setSearchData(searchCond);

    mutate(searchCond, {
      onSuccess: (data) => {
        setDropUserList(data);
        setIsSearch(true);
      },

      onError: () => {
        toast("데이터 조회 실패", "error");
      },
    });
  };

  const handleEnter = (key) => {
    if (key === "Enter") handleSearch();
  };

  return (
    <Wrapper>
      <Search.Text>월렛 탈퇴 회원 조회</Search.Text>
      <Search.Container>
        <Search.Content style={{ width: "90rem" }}>
          <Search.InputWrapper>
            {/* 회원명 */}
            <div>회원명</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setMemberName(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            {/* 회원코드 */}
            <div>회원코드</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setMemberCode(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            {/* 추천인명 */}
            <div>추천인명</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setRecommenderName(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            {/* 추천인코드 */}
            <div>추천인코드</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setRecommenderCode(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            {/* 전화번호 */}
            <div>전화번호</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setMobile(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper>
            {/* 이메일 */}
            <div>이메일</div>
            <Search.Input
              placeholder={PLACEHOLDER.ALL}
              onChange={(e) => setEmail(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          <Search.InputWrapper style={{ width: "25rem" }}>
            {/* 지갑주소 */}
            <div>메인지갑주소</div>
            <Search.Input
              placeholder={PLACEHOLDER.SOME}
              onChange={(e) => setWalletAddress(e.target.value)}
              onKeyUp={(e) => handleEnter(e.key)}
            />
          </Search.InputWrapper>

          {/* 가입일자 (부터) */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>가입일자 (부터)</div>
            <Search.Input
              type="date"
              defaultValue={createFromDt}
              onChange={(e) => setCreateFromDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>

          {/* 가입일자 (까지) */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>가입일자 (까지)</div>
            <Search.Input
              type="date"
              defaultValue={createToDt}
              onChange={(e) => setCreateToDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>

          {/* 탈퇴일자 (부터) */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>탈퇴일자 (부터)</div>
            <Search.Input
              type="date"
              defaultValue={deleteFromDt}
              onChange={(e) => setDeleteFromDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>

          {/* 탈퇴일자 (까지) */}
          <Search.InputWrapper style={{ padding: "0.5rem" }}>
            <div>탈퇴일자 (까지)</div>
            <Search.Input
              type="date"
              defaultValue={deleteToDt}
              onChange={(e) => setDeleteToDt(e.target.value)}
            ></Search.Input>
          </Search.InputWrapper>
        </Search.Content>

        {/* 조회 버튼 */}
        <Search.Btn onClick={() => handleSearch()}>조회</Search.Btn>
      </Search.Container>
    </Wrapper>
  );
};

export default WalletDropUserSearch;
